// graphql/oattvalidation.gql.ts

import { gql } from '@apollo/client';

// ── Fragment ─────────────────────────────────────────────────────────────────
export const OATT_VALIDATION_FRAGMENT = gql`
  fragment OattValidationFields on OattComputedRecord {
    oatt_computed_id
    raw_id
    seller
    aref
    customer_code
    billing_period
    billing_type
    mw_granted
    billing_rate
    hours
    start_time
    stop_time

    # OATI (billed) charges
    firm_transmission_charge_oatt
    nonfirm_transmission_charge_oatt
    ancillary_schedule1_oatt
    ancillary_schedule2_oatt
    total_charges_oatt

    # Computed charges
    firm_transmission_charge_computed
    nonfirm_transmission_charge_computed
    ancillary_schedule1_computed
    ancillary_schedule2_computed
    total_charges_computed

    adjustments

    # Validation fields
    oatt_data_source_selected
    comments
    approval
    approval_signature
    validated_status
    validated_at
    approved_at
    is_revision
    revision_no
  }
`;

// ── Query ─────────────────────────────────────────────────────────────────────
export const GET_OATT_VALIDATION = gql`
  ${OATT_VALIDATION_FRAGMENT}
  query GetOattValidation($month: Int!, $year: Int!, $customerId: Int) {
    getOattValidation(month: $month, year: $year, customerId: $customerId) {
      ...OattValidationFields
    }
  }
`;

// ── Mutation ──────────────────────────────────────────────────────────────────
export const SAVE_OATT_VALIDATION = gql`
  mutation SaveOattValidation($records: [ValidateOattRecordInput!]!) {
    saveOattValidation(records: $records) {
      success
      message
      updatedCount
    }
  }
`;